import { Link } from "react-router-dom";
import { Page } from "@/components/PublicLayout";
import { useBlocks, useCrisisLines, usePublicSettings } from "@/hooks/useContent";

const telHref = (phone) => `tel:${phone.replace(/[^\d+]/g, "")}`;

export default function CrisisPage() {
  const { data: blocks } = useBlocks();
  const { data: lines = [] } = useCrisisLines();
  const { data: ps } = usePublicSettings();
  const intro = blocks?.["crisis.intro"];
  const respond = blocks?.["crisis.how_we_respond"];
  const staffed = ps?.settings?.["urgent.staffed_hours"];
  const national = lines.filter((l) => l.kind !== "county");
  const county = lines.filter((l) => l.kind === "county");
  return (
    <Page title={intro?.title || "Crisis & Urgent Help"} lede={intro?.body} testId="crisis-page">
      <ul className="max-w-2xl divide-y divide-sage-400/50 border-y border-sage-400/50" data-testid="crisis-lines">
        {national.map((l) => (
          <li key={l.id} className="py-6" data-testid={`crisis-line-${l.id}`}>
            <h2 className="text-2xl">{l.name}</h2>
            <p className="mt-1 text-ink-900">{l.description}</p>
            <div className="mt-3 flex flex-wrap gap-3">
              {l.phone && <a href={telHref(l.phone)} className="btn-primary" data-testid={`crisis-call-${l.id}`}>Call {l.phone}</a>}
              {l.text_instructions && <span className="btn-secondary cursor-default">{l.text_instructions}</span>}
              {l.url && <a href={l.url} className="btn-quiet" target="_blank" rel="noopener noreferrer">Website</a>}
            </div>
            <p className="help mt-3">{l.verified_at ? `Verified ${new Date(l.verified_at).toLocaleDateString("en-US", { timeZone: "America/Los_Angeles" })}` : "Verification date: pending Care Director review"}</p>
          </li>
        ))}
      </ul>
      {county.length > 0 && (
        <section className="mt-14 max-w-2xl" aria-labelledby="county-heading">
          <h2 id="county-heading" className="text-3xl">County Crisis Lines</h2>
          <ul className="mt-6 divide-y divide-sage-400/50 border-y border-sage-400/50">
            {county.map((l) => (
              <li key={l.id} className="py-6">
                <h3 className="text-xl">{l.name}</h3>
                <p className="mt-1">{l.description}</p>
                {l.phone && <a href={telHref(l.phone)} className="btn-primary mt-3">Call {l.phone}</a>}
              </li>
            ))}
          </ul>
        </section>
      )}
      {respond && (
        <section className="surface mt-14 max-w-2xl p-6" aria-labelledby="respond-heading" data-testid="crisis-how-we-respond">
          <h2 id="respond-heading" className="text-2xl">{respond.title}</h2>
          <p className="mt-2">{respond.body}</p>
          {staffed && <p className="mt-2 text-sm text-ink-500" data-testid="crisis-staffed-hours">Staffed hours: {staffed.replace(/\s*\[PLACEHOLDER[^\]]*\]/, "")}</p>}
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to="/reach-out" className="btn-secondary" data-testid="crisis-reach-out-link">Reach Out</Link>
            <Link to="/portal/messages" className="btn-quiet" data-testid="crisis-portal-messages-link">Message My Care Team</Link>
          </div>
        </section>
      )}
    </Page>
  );
}
